import { InjectionToken } from '@angular/core';

export type BrandTheme = 'optimal' | 'office-ui' | 'dentifin';

export interface AppConfig {
  brandTheme: BrandTheme;
  logoSrc?: string;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
